window.addEventListener('load', function (event) {
  const variantsSelect = document.querySelectorAll('select[data-variants]');
  if (!variantsSelect || !variantsSelect.length) return;
  variantsSelect.forEach((selector) => {
    initVariantSelector(selector);
    selector.parentElement.removeChild(selector);
  });
});

function initVariantSelector(selector) {
  const productVariants = [];
  // todo: add property for outputs only
  for (const option of selector.options) {
    const variantInfo = {
      id: option.value,
      values: option.dataset.values,
      raw_price: option.dataset.raw_price,
      price: option.dataset.price,
      raw_compare_at_price: option.dataset.raw_compare_at_price,
      compare_at_price: option.dataset.compare_at_price,
      metafield_weight: option.dataset.metafield_weight,
      metafield_length: option.dataset.metafield_length,
      metafield_width: option.dataset.metafield_width,
      metafield_height: option.dataset.metafield_height,
      metafield_capacity: option.dataset.metafield_capacity,
      options: option.dataset.values.split('|'),
      available: option.dataset.hasOwnProperty('available'),
    };
    productVariants.push(variantInfo);
  }

  const productId = selector.dataset.variants;
  if (!productId) return;
  const productForm = document.querySelector(`form[data-product_form='${productId}']`);
  const productOptions = document.querySelectorAll(`[data-variant_options='${productId}']`);
  const productCard = document.querySelector(`[data-product_card='${productId}']`);
  const productPrice = productCard.querySelector("[data-output='price']");
  const productCompareAtPrice = productCard.querySelector("[data-output='compare_at_price']");
  const sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
  const variantInput = productForm.querySelector("input[name='id']");
  if (productOptions.length) {
    const convertCurrencyEvent = new CustomEvent('CurrencyConverterUpdate', {
      detail: { outputs: [productPrice, productCompareAtPrice] },
    });
    const variantUpdateEvent = new CustomEvent('ProductVariantUpdate', { detail: { variant: variantInput } });
    productOptions.forEach((option) => {
      const isImagesTrigger = option.dataset.hasOwnProperty('variantImagesTrigger');
      const isFamilyTrigger = option.dataset.hasOwnProperty('variantFamilyTrigger');
      const values = option.querySelectorAll('[data-value]');
      values.forEach((value) => {
        value.addEventListener('click', function () {
          if (value.dataset.hasOwnProperty('selected')) return;
          if (isFamilyTrigger) return;
          const current = option.querySelector('[data-selected]');
          if (current) current.removeAttribute('data-selected');
          value.dataset.selected = true;
          option.dataset.option_value = value.dataset.value;
          const selected = updateVariant(productOptions, productVariants, productForm);
          toggleForm(productForm, selected ? selected.available : false);
          if (isImagesTrigger)
            filterVariantImages(
              option.dataset.variant_options.toLowerCase(),
              option.dataset.option_value.toLowerCase()
            );
          if (selected) {
            productPrice.dataset.money = selected.raw_price;
            if (productCompareAtPrice.dataset.hasOwnProperty('active_class')) {
              const activeClass = productCompareAtPrice.dataset.active_class;
              if (selected.raw_compare_at_price && !productCompareAtPrice.classList.contains(activeClass))
                productCompareAtPrice.classList.add(activeClass);
              if (!selected.raw_compare_at_price) productCompareAtPrice.classList.remove(activeClass);
            }
            productCompareAtPrice.dataset.money = selected.raw_compare_at_price;
            document.body.dispatchEvent(convertCurrencyEvent);
            document.body.dispatchEvent(variantUpdateEvent);
          }
        });
      });
      if (isImagesTrigger) {
        window.addEventListener('load', function () {
          filterVariantImages(option.dataset.variant_options.toLowerCase(), option.dataset.option_value.toLowerCase());
        });
      }
    });
    // trigger variant images on load
    document.body.dispatchEvent(variantUpdateEvent);
  }
}

function updateVariant(options, variants, form) {
  const selectedOptions = [];
  options.forEach((option) => {
    selectedOptions.push(option.dataset.option_value);
  });
  const selectedVariant = variants.find((variant) => variant.values === selectedOptions.join('|'));

  if (!selectedVariant) return false;

  // var event = new CustomEvent('OrdersifyFormChange', { detail: { variantID: selectedVariant.id } });
  // document.body.dispatchEvent(event);
  const variantInput = form.querySelector("input[name='id']");
  if (variantInput) variantInput.value = selectedVariant.id;
  const sellingPlanInput = form.querySelector("input[name='selling_plan']");
  const requestedUrl = new URL(window.location.href);
  if (!requestedUrl.pathname.includes('collection'))
    updateProductUrl(variantInput.value, sellingPlanInput ? sellingPlanInput.value : null);
  const outputParent = document.querySelector(`[data-product_card='${form.dataset.product_form}']`);
  const variantOutput = outputParent
    ? outputParent.querySelectorAll('[data-output]')
    : document.querySelectorAll('[data-output]');
  variantOutput.forEach((output) => {
    if (output.dataset.output === 'images') {
      const current = output.querySelector('[data-active]');
      if (current) {
        current.classList.replace('db', 'dn');
        current.removeAttribute('data-active');
      }
      const updated = output.querySelector("[data-variant='" + selectedVariant.id + "']");
      if (updated) {
        updated.classList.replace('dn', 'db');
        updated.dataset.active = true;
      }
    } else {
      const outputPrefix = output.dataset.hasOwnProperty('prefix') ? output.dataset.prefix : '';
      const outputSuffix = output.dataset.hasOwnProperty('suffix') ? output.dataset.suffix : '';
      const outputText = outputPrefix + selectedVariant[output.dataset.output] + outputSuffix;
      output.textContent = outputText;
    }
  });

  return selectedVariant;
}

function toggleForm(form, isAvailable) {
  const submit = form.querySelector('[data-submit]');
  /*
  - !isAvailable && submit.disabled = nothing happens
  - !isAvailable && !submit.disabled = toggle submit button to disabled
  - isAvailable && !submit.disabled = nothing happens
  - isAvailable && submit.disabled = toggle submit button to enabled
  */
  if ((isAvailable && !submit.disabled) || (!isAvailable && submit.disabled)) return;
  const notSubmit = !submit.disabled;
  submit.disabled = notSubmit;
  submit.classList.toggle('opacity-50');
  submit.classList.toggle('opacity-100');
  submit.classList.toggle('lg:hover:opacity-50');
}

function formatSelectOptionsText(options, current, prepend, append) {
  for (const option of options) {
    if (option.index === current) {
      if (prepend) option.text = prepend + option.text;
      if (append) option.text = option.text + append;
    } else {
      if (prepend) option.text = option.text.replace(prepend, '');
      if (append) option.text = option.text.replace(append, '');
    }
  }
}

function filterVariantImages(option, value) {
  $('[data-variant-images]').slick('slickUnfilter');
  $('[data-variant-images]').slick('slickFilter', `.${option}-${value}, .options-all`);
}

/* const quantityInput = document.querySelector("div[data-input='quantity']");
if (quantityInput) {
  const productQuantity = document.querySelector("input[name='quantity']");
  initQuantityInput(quantityInput, function (input, value) {
    productQuantity.value = value;
  });
} */
